import { Box, Typography } from '@mui/material';
import CurrencySelector from 'components/controls/CurrencySelector';
import { useContext } from 'react';
import { BudgetMonthContext } from './BudgetMonthContextProvider';

const BudgetMonthCurrency = () => {
  const { selectedCurrency, onUpdateCurrency } = useContext(BudgetMonthContext);
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between'
      }}
    >
      <Typography variant="body1">Currency:</Typography>
      <CurrencySelector value={selectedCurrency} onChange={onUpdateCurrency} />
    </Box>
  );
};

export default BudgetMonthCurrency;
